export const PUBLIC_ROUTES = [
  "/experts_booking_system",
  "/directory-testing",
  "/company/expert-meeting/book-meeting",
  "/booking-system",
];
